<template>
  <div id="balance" class="app-content-wrapper app-content-control">
    <div class="app-content-padding app-detail-title app-top-distance">
      {{ $t('message.tableCommon.currency') }}
      <span class="b-title-illustrate"> {{ $t('message.settlement.currencyViewed') }}</span>
    </div>
    <div class="b-button-wrap">
      <template v-for="(item,index) of buttonList">
        <el-button :type="'primary'"
                   :class="{'button-uncheck':!item.checked }"
                   @click="onClickCurrency(item)"
                   :key="index">
          {{ $t(item.label) }}
        </el-button>
      </template>
    </div>
    <div class="app-top-distance">
      <div class="app-content-padding app-detail-title">
        {{ $t('message.settlement.accountBalance') }}
        <span class="b-title-illustrate"> ( {{
            $t('message.payee.distributableQuota')
          }} {{ distributableQuota.balance }} {{ distributableQuota.currency }} )</span>
      </div>
      <div class="b-balance-wrap">
        <template v-for="(item,index) of totalAmountList">
          <div class="total-amount-inline amount-vertical" :key="index">
            <div class="total-amount-top" :title="item.value">
              {{ item.value }}
            </div>
            <div class="total-amount-bottom">
              {{ $t(item.label) }}
            </div>
          </div>
        </template>
      </div>
    </div>
    <div class="app-content-padding app-detail-title app-top-distance b-search">
      <div class="b-search-title">
        {{ $t('message.settlement.accountDetails') }}
      </div>
      <search-component ref="search"
                        :search-condition="searchCondition"
                        @toSearch="onSearch"
                        :is-search-button-inline="true">
      </search-component>
    </div>
    <div>
      <custom-table
        ref="table"
        router-name="/settlement/balance"
        :additional-parameters="defaultParameters"
        :is-first-automatic-visit="false"
        :is-watch-path-change="false"
        :service-function="getAccountChangeDetail"
        :tableSet="tableCondition"></custom-table>
    </div>
  </div>
</template>

<script>

import { getDictionary } from '@/api/common';
import CustomTable from '@/components/table/custom-table.vue';
import SearchComponent from '@/components/table/search-component';
import { getEnantiomericValue, initSelectedData } from '@/utils/tools/constant';
import { comparisonObject, shallowClones } from '@/utils/tools/utils';
import BalancesService from '@/views/settlement/api/settlement-balance';

export default {
  name: 'DetailsComponent',
  components: { SearchComponent, CustomTable },
  data() {
    return {
      defaultParameters: {},
      buttonList: [],
      totalAmountList: [],
      txnTypeList: [],
      distributableQuota: {},
      searchCondition: [
        {
          key: ['createTimeStart', 'createTimeEnd'],
          name: '',
          type: 'date_time',
        },
        {
          key: 'acntTxnType',
          name: '',
          type: 'select',
          defValue: '',
          placeholder: 'message.settlement.accountTxnType',
          options: [],
        },
      ],
      tableCondition: [
        { // 账户交易时间
          titleBar: { type: 'text', title: 'message.settlement.accountTxnTime' },
          key: 'createTime',
          type: 'text',
        },
        { // 结算币种
          titleBar: { type: 'text', title: 'message.settlement.currency' },
          key: 'currency',
          type: 'text',
        },
        { // 账户交易类型
          titleBar: { type: 'text', title: 'message.settlement.accountTxnType' },
          key: 'acntTxnType',
          type: 'text',
          textFunc: (data) => getEnantiomericValue(this.txnTypeList, data.acntTxnType),
        },
        { // 变动金额
          titleBar: { type: 'text', title: 'message.settlement.changeAmount' },
          key: 'txnAmount',
          type: 'text',
          textFunc: (data) => data.txnAmount,
        },
        // { // 账户余额
        //   titleBar: { type: 'text', title: 'message.settlement.accountBalance' },
        //   key: 'accountBalance',
        //   type: 'text',
        //   textFunc: (data) => data.accountBalance,
        // },
      ],
    };
  },
  created() {
    getDictionary(['ACNTTXN_TYPE']).then((res) => {
      this.txnTypeList = initSelectedData(res.ACNTTXN_TYPE, 'description', 'value', false);
      this.$refs.search.setSearchSelectOptions('acntTxnType', this.txnTypeList);
    }).catch(() => {
    });
    this.httpGetAccountBalances();
  },
  methods: {
    ...BalancesService,
    httpGetAccountBalances() {
      this.getAccountBalances().then(data => {
        if (data) {
          this.buttonList = [];
          data.forEach((item, index) => {
            this.buttonList.push({ label: item.currency, checked: index === 0, value: item });
            if (index === 0) {
              this.totalAmountList = this.getBalanceArray(item);
              this.httpGetCollectBalance(item.currency, false);
            }
          });
          this.$refs.table.httpGetList(this.defaultParameters);
        }
      });
    },
    onClickCurrency(subItem, isHttps = true) {
      this.buttonList.forEach(item => {
        item.checked = false;
      });
      subItem.checked = true;
      this.totalAmountList = this.getBalanceArray(subItem.value);
      if (isHttps) {
        this.$refs.table.httpData(this.defaultParameters);
        this.httpGetCollectBalance(subItem.label);
      }
    },
    httpGetCollectBalance(currency) {
      this.getCollectBalance({ currency }).then(data => {
        this.distributableQuota = data;
      });
    },
    onSearch(params) {
      this.$refs.table.httpData(shallowClones(this.defaultParameters, params));
    },
    getBalanceArray(data) {
      this.defaultParameters = { acntId: data.acntId };
      return [
        { label: 'message.settlement.accountTotalAmount', value: data.totalBalance && data.totalBalance.amount },
        { label: 'message.settlement.pendingSettledAmount', value: data.unsettleBalance && data.unsettleBalance.amount },
        { label: 'message.settlement.frozenAmount', value: data.freezeBalance && data.freezeBalance.amount },
        { label: 'message.settlement.marginAmount', value: data.depositBalance && data.depositBalance.amount },
        { label: 'message.settlement.availableBalance', value: data.availBalance && data.availBalance.amount },
      ];
    },
  },
  watch: {
    $route: function(to, from) {
      if (comparisonObject({}, this.$route.query)) {
        this.httpGetAccountBalances();
      } else {
        const item = this.buttonList.find(subItem => subItem.value.acntId === this.$route.query.acntId);
        this.onClickCurrency(item, false);
        this.$refs.table.httpGetList(this.$route.query);
      }
    },
  },
};
</script>

<style lang="scss">
#balance {
  @import '@/styles/variables.scss';

  .b-title-illustrate {
    color: $color-description;
    font-size: 14px;
    padding-left: 5px;
  }

  .b-button-wrap {
    white-space: nowrap;
    overflow: auto hidden;
    padding: 20px 30px 30px;
    border-bottom: 4px solid $color-bg;

    .el-button {
      width: 120px;
      height: 40px;
      border-radius: 20px;
      border: 0px;
    }

    .button-uncheck {
      background: rgba(241, 243, 255, 1);
      color: $color-primary;

      &:hover {
        background: rgba(97, 120, 255, .2);
      }
    }
  }

  .b-search-title {
    height: 42px;
    line-height: 42px;
  }

  .b-balance-wrap {
    display: flex;
    align-items: center;
    height: 140px;
    background: $color-bg;
    border-radius: 8px;
    border: 1px solid $color-disabled;
    margin: 30px 30px 0;

    .total-amount-top {
      width: 100%;
      height: 29px;
      font-weight: bold;
      color: $color-text-primary;
      line-height: 29px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .total-amount-bottom {
      font-size: 14px;
      font-weight: 500;
      color: $color-description;
      line-height: 20px;
    }

    .amount-vertical {
      text-align: center;
      font-size: 20px;
      width: 15%;
      padding: 0 15px;

      &:nth-child(1) {
        width: 20%;
        font-size: 24px;
      }
    }

    .total-amount-inline {
      float: left;

      &:after {
        content: '';
        display: block;
        clear: both;
      }
    }
  }

  .b-search {
    display: flex;
    justify-content: space-between;

    .el-form-item:last-child {
      margin-right: 0px;
    }
  }

}
</style>
